export default __webpack_public_path__ + "static/media/Old_Bottom.d53bd5db.dwg";